import { render, staticRenderFns } from "./SpecimenList.vue?vue&type=template&id=572bc046&"
import script from "./SpecimenList.vue?vue&type=script&lang=js&"
export * from "./SpecimenList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports